module.exports = "/lucky-balls/video/intro_mk.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/video/intro_mk.mp4
// module id = 888
// module chunks = 0